<template>
  <div>
    <h2 v-if="!noHeader" class="my-5">
      <b>Choose File For Signing</b>
    </h2>
    <div v-if="!selectedFile">
      <div class="file-upload-area mt-5">
        <input type="file" @change="loadFiles" class="file-upload" />
        <div class="input-file-selector">
          <img class="doc-icn my-4" src="../assets/images/paper.svg" />
          <div>
            <h5><b>Drag and drop file to process</b></h5>
            or
          </div>
          <button class="mt-2 btn">Select file</button>
        </div>
      </div>
    </div>
    <div v-else class="file-selected-area mt-5 text-center">
      <img class="doc-icn my-4" src="../assets/images/paper.svg" />
      <h5>
        <b>{{ selectedFile.name }}</b>
        <span @click="selectedFile = null" class="removefile">&times;</span>
      </h5>
    </div>
    <div v-if="nextHandler" class="d-flex pt-5 steps-button">
      <button class="btn back-btn ml-0 mr-auto" @click="nextHandler(0)">
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button class="btn next-btn ml-auto mr-0" @click="nextHandler(2)" :disabled="!isStepComplete">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
  </div>
</template>
<script>
import bytesToSize from "../functions/bytesToSize"
export default {
  name: "FileSelector",
  props: {
    nextHandler: Function,
    fileSelectorCB: Function,
    noHeader: Boolean,
  },
  data() {
    return {
      selectedFile: null,
      isStepComplete: false,
    }
  },
  methods: {
    loadFiles($event) {
      var files = event.target.files
      if (files) {
        this.selectedFile = files[0]
        this.fileSelectorCB(this.selectedFile)
        localStorage.removeItem('OTUbackup')
        this.isStepComplete = true
      }
    },
    bytesToSize,
  },
}
</script>
<style scoped>
.file-upload-area {
  border: 5px dashed var(--border-color);
  border-radius: 10px;
  height: 350px;
  background-color: var(--background-primary);
}

.file-selected-area {
  height: 350px;
}

.file-upload {
  width: 100%;
  height: 100%;
  align-items: center;
  text-align: center;
  opacity: 0;
}

.input-file-selector {
  align-items: center;
  text-align: center;
  color: #888888;
  margin-top: -350px;
  height: 350px;
  padding-top: 40px;
}

.input-file-selector button {
  background: #10a2e6;
  color: rgb(233, 233, 233);
  font-size: 13px;
  font-weight: 500;
}

tr {
  max-width: 100%;
  overflow: hidden;
}

td,
th {
  min-width: 130px;
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 8px;
}

.doc-icn {
  width: 100px;
}

.text-blue {
  color: #10a2e6;
}

.removefile {
  font-size: larger;
  cursor: pointer;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/FileSelector.vue